module.exports = __webpack_public_path__ + "img/type--4-spans--single-lang--fr.92767fce.jpg";